/*============================================================================
  Search autocomplete
==============================================================================*/
var searchAutocomplete = {
    init: function(){

        var currentAjaxRequest = null;
        var shopURL = $('body').data('shop-url');
        var searchPath = window.Shopify.routes.root + 'search?q=';
        var $searchResultsWrapper = $('.search__results-wrapper');
        var input = $('form.search-modal__wrapper').find('input[name="q"]');

        $(".search-modal__wrapper").on("submit", function(e){
            e.preventDefault();

            var formValue = $(this).find('input[name="q"]').val();
            var cleanFormValue = encodeURI(formValue);

            if(cleanFormValue == null) {
                window.location.href = window.Shopify.routes.root + 'search';
            } else {
                window.location.href = searchPath + cleanFormValue + '&type=product,article';
            }
        });

        if($searchResultsWrapper){
            $searchResultsWrapper.remove();
        }

        if($(window).width() < 992 ){
            $('<div class="search__results-wrapper"><div class="search__results-wrapper-content"><ul class="search__results"></ul></div></div>').appendTo($('.js-mobile-search-wrapper')).hide();
        }else{
            $('<div class="search__results-wrapper"><div class="search__results-wrapper-content"><ul class="search__results"></ul></div></div>').appendTo($('.site-header .wrapper')).hide();
        }
        // Listening to keyup and change on the text field within these search forms.
        input.attr('autocomplete', 'off').bind('keyup change', function() {
            if(input.val() == '') {
                $('.search__results').hide();
                $('.search__results-wrapper').hide();
                $('.search__results').empty();
            }

            var term = $(this).val();
            var cleanTerm = encodeURI(term);
            var searchURL =  searchPath + cleanTerm;
            var resultsList = $('header').find('.search__results');
            if (term.length > 2) {
                if (currentAjaxRequest != null){
                    currentAjaxRequest.abort();
                }

                $.getJSON(searchURL +'&view=json', function(data) {
                    resultsList.empty();
                        // If we have no results.
                    if(data.results_count == 0) {
                        resultsList.hide();
                        $('.search__results-wrapper').hide();
                    } else {
                            // If we have results.
                        $.each(data.results, function(index, item) {
                            if(index >= 3) {
                                return false;
                            }
                            var link = $('<a></a>').attr('href', item.url);

                            if(item.thumbnail != 'NULL') {
                                link.append('<div class="thumbnail"><img class="lazyload" src="' + item.thumbnail + '" /></div>');
                            }
                            link.append('<div class="paragraph">' + item.title + '</div>');

                            link.wrap('<li class="item-result result--' + item.object_type + '"></li>');
                            resultsList.append(link.parent());
                        });
                            // The Ajax request will return at the most 3 results.
                            // If there are more than 3, let's link to the search results page.
                        if(data.results_count >= 3) {
                            resultsList.append(`<li class="all-results item-result"><a class="paragraph--small-bold" href="${searchURL}">${theme.strings.searchFor} "${term}"</a></li>`);
                        }
                        resultsList.fadeIn(200);
                        $('.search__results-wrapper').fadeIn(200);
                    }
                })
            }
        });

        $('.search-modal__close').on('click', function (){
            $(this).parent().parent().removeClass('show-nav-block');
            $('.search__results-wrapper').remove();
            $('.js-mobile-search-wrapper').addClass('hide');
            $('.header-container').removeClass('mobile-nav--height');
            $('.js-header-container').removeClass('open-desktop-search').removeClass('mobile-fixed-header');
            //$('.mobile-menu').removeClass('open-mobile-menu');
            $('body').removeClass('static-body');
        });
    },
    unload: function() {
        $('body').off('focus', '[data-autocomplete-true] input');
    }
}


$('.js-toggle-search-modal').click(function (ev) {
    ev.preventDefault();
    searchAutocomplete.init();
    if($(window).width() < 992 ){
        if(!$('.header-container').hasClass('mobile-nav--height')){
            $('.header-container').addClass('mobile-nav--height');
        }
        $('.js-mobile-search-wrapper').removeClass('hide');
        $('.js-mobile-menu-wrapper').hide();
        $('.mobile-toggles--close').addClass('hide');
        $('.mobile-toggles--open').removeClass('hide');
        $('.js-header-container').addClass('mobile-fixed-header');
        //$('.mobile-menu').addClass('open-mobile-menu');
        $('body').addClass('static-body');
    }else{
        $('.site-nav__dropdown').removeClass('show-nav-block');
        $('#MenuParent-'+$(this).data('child-block')).addClass('show-nav-block');
        $('.js-header-container').addClass('open-desktop-search');
    }
});

if ($(window).width() < 591) {

        searchAutocomplete.init();

}

